// extracted by mini-css-extract-plugin
module.exports = {"root":"slider_root__Pbqaq","track":"slider_track__M_FCT","range":"slider_range__0iR_P","thumb":"slider_thumb__X_vZZ"};